export type PollMetricResponse = {
  value: unknown;
};

export type PollMetricInvite = {
  completedAt?: string | null;
};

export const getCurrentPollScore = (
  responses: PollMetricResponse[] | null | undefined
): number | undefined => {
  const values = (responses ?? [])
    .map((response) =>
      typeof response.value === "number" ? response.value : Number(response.value)
    )
    .filter((value) => Number.isFinite(value));

  if (values.length === 0) return undefined;
  return values.reduce((sum, value) => sum + value, 0) / values.length;
};

export const getPollCompletion = (
  invites: PollMetricInvite[] | null | undefined
) => {
  const total = invites?.length ?? 0;
  const completed = (invites ?? []).filter((invite) => Boolean(invite.completedAt)).length;
  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

  return { total, completed, percentage };
};
